
import { Device } from '../DeviceTypes';
import { mockSmartWaterMeters } from '@/lib/mock-data/water/smart-meters';
import { mapSmartMetersToDevices } from '../utils/deviceMappers';

// Create device objects from imported water smart meters
export const waterSmartMeterDevices = mapSmartMetersToDevices(mockSmartWaterMeters, 'Water');

// Static Water department devices
export const staticWaterDevices: Device[] = [
  {
    id: 'WQS-2023-003',
    name: 'Water Quality Sensor 003',
    type: 'water',
    category: 'Quality Sensor',
    serial: 'WQS-2023-003',
    status: 'maintenance',
    lastActive: '2023-10-12T09:15:00Z',
    department: 'Water'
  },
  {
    id: 'WPM-2023-007',
    name: 'Water Pressure Monitor 007',
    type: 'water',
    category: 'Pressure Monitor',
    serial: 'WPM-2023-007',
    status: 'active',
    lastActive: '2023-10-15T08:10:00Z',
    department: 'Water'
  },
  {
    id: 'WLM-2023-015',
    name: 'Water Level Monitor 015',
    type: 'water',
    category: 'Level Monitor',
    serial: 'WLM-2023-015',
    status: 'active',
    lastActive: '2023-10-14T09:40:00Z',
    department: 'Water'
  },
  {
    id: 'WFM-2023-019',
    name: 'Water Flow Meter 019',
    type: 'water',
    category: 'Flow Meter',
    serial: 'WFM-2023-019',
    status: 'active',
    lastActive: '2023-10-16T12:35:00Z',
    department: 'Water'
  },
  {
    id: 'WIG-2023-024',
    name: 'Water IoT Gateway 024',
    type: 'water',
    category: 'IoT Gateway',
    serial: 'WIG-2023-024',
    status: 'active',
    lastActive: '2023-10-17T14:20:00Z',
    department: 'Water'
  },
  // Additional mapped devices that were previously unmapped
  {
    id: 'WAT-84591',
    name: 'Regional Medical Center',
    type: 'water',
    category: 'Smart Meter',
    serial: 'WAT-84591',
    status: 'active',
    lastActive: '2023-10-19T14:25:00Z',
    department: 'Water'
  },
  {
    id: 'WAT-28473',
    name: 'University Gardens Campus',
    type: 'water',
    category: 'Smart Meter',
    serial: 'WAT-28473',
    status: 'active',
    lastActive: '2023-10-18T09:30:00Z',
    department: 'Water'
  },
  {
    id: 'WAT-39284',
    name: 'Greenview Golf Course',
    type: 'water',
    category: 'Irrigation System',
    serial: 'WAT-39284',
    status: 'active',
    lastActive: '2023-10-20T10:15:00Z',
    department: 'Water'
  },
  {
    id: 'WAT-67823',
    name: 'Central Hospital',
    type: 'water',
    category: 'Smart Meter',
    serial: 'WAT-67823',
    status: 'active',
    lastActive: '2023-10-19T15:40:00Z',
    department: 'Water'
  },
  {
    id: 'WAT-51392',
    name: 'Harbor View Apartments',
    type: 'water',
    category: 'Smart Meter',
    serial: 'WAT-51392',
    status: 'active',
    lastActive: '2023-10-17T13:25:00Z',
    department: 'Water'
  },
  {
    id: 'WAT-42973',
    name: 'City Hall',
    type: 'water',
    category: 'Municipal',
    serial: 'WAT-42973',
    status: 'active',
    lastActive: '2023-10-16T11:10:00Z',
    department: 'Water'
  },
  {
    id: 'WAT-63015',
    name: 'Marina Bay Complex',
    type: 'water',
    category: 'Smart Meter',
    serial: 'WAT-63015',
    status: 'active',
    lastActive: '2023-10-18T14:35:00Z',
    department: 'Water'
  },
  {
    id: 'WAT-17584',
    name: 'Central Public Pool',
    type: 'water',
    category: 'Municipal',
    serial: 'WAT-17584',
    status: 'active',
    lastActive: '2023-10-17T10:45:00Z',
    department: 'Water'
  },
  {
    id: 'WAT-93726',
    name: 'Mountain View Apartments',
    type: 'water',
    category: 'Residential',
    serial: 'WAT-93726',
    status: 'active',
    lastActive: '2023-10-19T09:20:00Z',
    department: 'Water'
  }
];

// All water devices combined
export const allWaterDevices: Device[] = [
  ...staticWaterDevices,
  ...waterSmartMeterDevices
];
